export function isUndefined(x: any) {
  return typeof x === 'undefined' || x === null;
}
